export class VersionMessage {
    version: string;
    environmentReadableMessage: string;
    environment: string;
    utcTime: Date;
    time: Date;
}